let language = {
    "RESOURCE-LIBRARY-PARTNER-INACTIVE-MESSAGE": "The current resource library is empty, please click here to create your resource library",
    "RESOURCE-LIBRARY-PARTNER-INACTIVE-BUTTON-CREATE": "create",
    "RESOURCE-LIBRARY-PARTNER-INACTIVE-BUTTON-LIBRARY": "library",

    // 侧边栏
    "RESOURCE-LIBRARY-SIDE-BAR-BUTTON-CREATE": "Create New Catalog",
    "RESOURCE-LIBRARY-SIDE-BAR-BUTTON-FILL-SETTING": "Fill Setting",
    "RESOURCE-LIBRARY-SIDE-BAR-OPTIONS-BUTTON-RENAME": "Rename",
    "RESOURCE-LIBRARY-SIDE-BAR-OPTIONS-BUTTON-DELETE": "Delete",
    "RESOURCE-LIBRARY-SIDE-BAR-OPTIONS-BUTTON-FILL-MODE": "Fill Mode",

    // 内容区
    "RESOURCE-LIBRARY-FUNCTION-BAR-BUTTON-SEARCH": "search",
    "RESOURCE-LIBRARY-FUNCTION-BAR-BUTTON-RESET": "reset",
    "RESOURCE-LIBRARY-FUNCTION-BAR-BUTTON-UPLOAD": "upload files",

    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-SELECT-ALL": "Select All",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-SELECTED": "Selected",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-MOVE": "move to",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-COPY": "copy to",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-FILL-SETTING": "Fill Setting",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-DELETE": "delete",
    "RESOURCE-LIBRARY-FILE-LIST-TIPS-FILE-EMPTY": "There is no match for the search criteria",
    "RESOURCE-LIBRARY-FILE-LIST-TIPS-LIBRARY-EMPTY": "The current resource library does not have a catalog",
    "RESOURCE-LIBRARY-FILE-LIST-TIPS-CATALOG-EMPTY": "The current catalog is empty",

    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-PREVIEW": "Preview",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-MOVE": "Move to",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-COPY": "Copy to",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-DELETE": "Delete",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-FILL-MODE": "Fill Mode",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-LOAD-MORE": "Load More",

    // create-catalog-modal
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-TITLE-NEW": "Create new catalog",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-TITLE-RENAME": "Rename catalog",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-NEW": "New Catalog",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-RENAME": "New Catalog Name",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-PLACEHOLDER": "Please enter catalog name",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-ERROR-TIPS": `The file name cannot contain the following characters: \ / : * ? " &lt; &gt; |`,
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-EMPTY-TIPS": `The name cannot be empty.`,
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-BUTTON-CANCEL": "Cancel",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-BUTTON-CREATE": "Create",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-BUTTON-RENAME": "Rename",

    // fill-mode-modal
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-TITLE": "Fill Setting",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-DESCRIPTION": "Select a default image fill",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-BUTTON-CANCEL": "Cancel",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-BUTTON-SAVE": "Save",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-CROP": "Crop",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-CONTAIN": "Contian",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-FILL": "Fill",
    
    // move-file-tree-modal
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-TITLE-COPY": "Copy to Catalog",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-TITLE-MOVE": "Move to Catalog",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-INPUT-PLACEHOLDER": "Folder name",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-CONFIRM": "confirm",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-CANCEL": "cancel",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-NEW": "create new folder",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-MOVE": "move",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-COPY": "copy",
        
    // file-preview-modal
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-TITLE": "Preview",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-IMAGE": "Image",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-DOWNLOAD": "Download",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-VIEW": "View",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-MOVE": "Move to",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-COPY": "Copy to",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-DELETE": "Delete",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-EDIT": "Edit file name",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-CANCEL": "Cancel",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-OK": "Ok",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-FILE-BUTTON-MOVE": "move",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-FILE-BUTTON-COPY": "copy",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-FILE-NAME-FORMAT": "The file name cannot contain the following characters: \\ \/ \: \* \? \" \< \> \|",

    // upload-result-modal
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-TITLE": "Upload Files",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-HEADER-IMAGE": "image",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-HEADER-INFO": "info",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-HEADER-STATUS": "status",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-NAME": "Name",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-TYPE": "Type",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-SIZE": "Size",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-MESSAGE": "Message",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-TIPS": "Uploading file, after closing upload file will be lost! Are you sure to close upload modal?",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-CONFIRM": "confirm",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-CANCEL": "cancel",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-UPLOAD": "upload",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-OK": "ok",
    
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-SVG-IMAGE": "The svg file exists in an external link file",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-SVG-FILTER": "The feComposite tag in the filter contains the 'in' attribute",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-SVG-RGBA": "Unsupported rgba function",
};

export { language }